import int01 from "./Introduccion/Intro-01.mp3";
import int02 from "./Introduccion/Intro-02.mp3";
import int03 from "./Introduccion/Intro-03.mp3";

import sub1a01 from "./Subtema-1/T7-Sub 1-Act 1-A01.mp3";
import sub1a02 from "./Subtema-1/T7-Sub 1-Act 1-A02.mp3";
import sub1a03 from "./Subtema-1/T7-Sub 1-Act 1-A03.mp3";
import sub1a04 from "./Subtema-1/T7-Sub 1-Act 1-A04.mp3";
import sub1a05 from "./Subtema-1/T7-Sub 1-Act 1-A05.mp3";
import sub1a06 from "./Subtema-1/T7-Sub 1-Act 1-A06.mp3";
import sub1a07 from "./Subtema-1/T7-Sub 1-Act 1-A07.mp3";

import sub1a08 from "./Subtema-1/T7-Sub 1-Act 2-A01.mp3";
import sub1a09 from "./Subtema-1/T7-Sub 1-Act 2-A02.mp3";
import sub1a10 from "./Subtema-1/T7-Sub 1-Act 2-A03.mp3";
import sub1a11 from "./Subtema-1/T7-Sub 1-Act 2-A04.mp3";
import sub1a12 from "./Subtema-1/T7-Sub 1-Act 2-A05.mp3";
import sub1a13 from "./Subtema-1/T7-Sub 1-Act 2-A06.mp3";
import sub1a14 from "./Subtema-1/T7-Sub 1-Act 2-A07.mp3";

import sub2a1a01 from "./Subtema-2/Actividad-1/T7-Sub 2-Act 1-A01.mp3";
import sub2a1a06 from "./Subtema-2/Actividad-1/T7-Sub 2-Act 1-A06.mp3";
import sub2a1a07 from "./Subtema-2/Actividad-1/T7-Sub 2-Act 1-A07.mp3";
import sub2a1a08 from "./Subtema-2/Actividad-1/T7-Sub 2-Act 1-A08.mp3";
import sub2a1a09 from "./Subtema-2/Actividad-1/T7-Sub 2-Act 1-A09.mp3";
import sub2a1a10 from "./Subtema-2/Actividad-1/T7-Sub 2-Act 1-A10.mp3";
import sub2a1a11 from "./Subtema-2/Actividad-1/T7-Sub 2-Act 1-A11.mp3";
import sub2a1n02 from "./Subtema-2/Actividad-1/T7-Sub 2-Act 1-N02.mp3";
import sub2a1n04 from "./Subtema-2/Actividad-1/T7-Sub 2-Act 1-N04.mp3";
import sub2a1r03 from "./Subtema-2/Actividad-1/T7-Sub 2-Act 1-R03.mp3";
import sub2a1r05 from "./Subtema-2/Actividad-1/T7-Sub 2-Act 1-R05.mp3";

import sub2a2a01 from "./Subtema-2/Actividad-2/T7-Sub 2-Act 2-A01.mp3";
import sub2a2n02 from "./Subtema-2/Actividad-2/T7-Sub 2-Act 2-N02.mp3";
import sub2a2n04 from "./Subtema-2/Actividad-2/T7-Sub 2-Act 2-N04.mp3";
import sub2a2r03 from "./Subtema-2/Actividad-2/T7-Sub 2-Act 2-R03.mp3";

import sub2a3a01 from "./Subtema-2/Actividad-3/T7-Sub 2-Act 3-A01.mp3";
import sub2a3a02 from "./Subtema-2/Actividad-3/T7-Sub 2-Act 3-A02.mp3";

import sub2a5a01 from "./Subtema-2/Actividad-5/T7-Sub 2-Act 5-A01.mp3";
import sub2a5a02 from "./Subtema-2/Actividad-5/T7-Sub 2-Act 5-A02.mp3";
import sub2a5a03 from "./Subtema-2/Actividad-5/T7-Sub 2-Act 5-A03.mp3";
import sub2a5a04 from "./Subtema-2/Actividad-5/T7-Sub 2-Act 5-A04.mp3";
import sub2a5a05 from "./Subtema-2/Actividad-5/T7-Sub 2-Act 5-A05.mp3";


export const T7_voices = {
	introduccion: {
		int01,
		int02,
		int03,
	},
	subtema1: {
		actividad1: {
			sub1a01,
			sub1a02,
			sub1a03,
			sub1a04,
			sub1a05,
			sub1a06,
			sub1a07,
		},
		actividad2: {
			sub1a08,
			sub1a09,
			sub1a10,
			sub1a11,
			sub1a12,
			sub1a13,
			sub1a14,
		}
	},
	subtema2: {
		actividad1: {
			sub2a1a01,
			sub2a1a06,
			sub2a1a07,
			sub2a1a08,
			sub2a1a09,
			sub2a1a10,
			sub2a1a11,
			sub2a1n02,
			sub2a1n04,
			sub2a1r03,
			sub2a1r05,
		},
		actividad2: {
			sub2a2a01,
			sub2a2n02,
			sub2a2n04,
			sub2a2r03,
		},
		actividad3: {
			sub2a3a01,
			sub2a3a02,
		},
		actividad5: {
			sub2a5a01,
			sub2a5a02,
			sub2a5a03,
			sub2a5a04,
			sub2a5a05,
		},
	},
};
